import MeetingsPageMobile from "./MeetingsPageMobile";

function MeetingsPageMain() {
  return <MeetingsPageMobile />;
}

export default MeetingsPageMain;
